import { useEffect, useState } from 'react';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { getSelectedSite } from '@/helpers/utils/siteUtils';

interface Props {
  className?: string;
  year: string;
  price: any;
  ppm?: string;
  required?: boolean;
  id?: string;
  warrantyVariant?: string;
  selectedWarrantySku?: string;
  setSelectedWarrantySku: (value: string) => void;
}

export const YearPlan: React.FC<Props> = ({
  className,
  year,
  price,
  ppm,
  id,
  warrantyVariant,
  selectedWarrantySku,
  setSelectedWarrantySku,
}) => {
  const isChecked = !!warrantyVariant && selectedWarrantySku === warrantyVariant;
  const selectedSite = getSelectedSite();
  const [ppmClass, setPpmClass] = useState('ppmZBColorClass');

  useEffect(() => {
    if (selectedSite === 'ZBSite') {
      setPpmClass('ppmZBColorClass');
    } else if (selectedSite === 'ZYSite') {
      setPpmClass('ppmZYColorClass');
    } else if (selectedSite === 'ZDSite') {
      setPpmClass('ppmZDColorClass');
    }
  }, [selectedSite]);
  return (
    <li className="list-none">
      <label
        htmlFor={id ? id : year}
        className={`${className} ${
          isChecked ? 'border-2 border-forestGreen px-[15px] py-[11px]' : 'border border-foggyGray px-4 py-3'
        }`}
      >
        <input
          id={id ? id : year}
          type="checkbox"
          value={year}
          name="year plan"
          className="size-6 shrink-0 cursor-pointer rounded-sm border-2 border-black bg-white text-forestGreen shadow-none checked:!border-forestGreen checked:!bg-forestGreen focus:outline-none focus:ring-0"
          checked={isChecked}
          onChange={(e) => setSelectedWarrantySku(e.target.checked ? warrantyVariant ?? '' : '')}
        />
        <span className="flex flex-col text-left">
          <span className="text-base leading-5 text-black">
            <strong>
              {year} {mapLocaleToMeaningfulFormat().protectionPlan}
            </strong>
            {price ? <> - {price}</> : <></>}
          </span>
          {ppm && ppm !== '' ? (
            <span className={`text-sm font-semibold leading-[18px] ${ppmClass}`}>{ppm}</span>
          ) : (
            <></>
          )}
        </span>
      </label>
    </li>
  );
};
